import styled, { css } from "styled-components";
import { BORDER_COLORS, COLORS, TEXT_COLORS } from "../../../constants/design/colors";
import { FONT_CSS } from "../../../constants/design/fontSize";
import { SPACING } from "../../../constants/design/spacing";

export type CheckboxType = "outline" | "default";

export const CheckboxContainer = styled.div<{ isActive?: boolean; type?: CheckboxType }>`
  ${FONT_CSS.body.five}
  display: flex;
  position: relative;
  align-items: center;

  &:hover {
    cursor: pointer;
  }

  transition: 0.2s ease-in-out;
  color: ${({ isActive, type }) => {
    if (type === "outline") {
      return TEXT_COLORS.three;
    }
    return isActive ? COLORS.highlight.one : COLORS.highlight.two;
  }};

  div {
    border-radius: 4px;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;

    &:not(:last-child) {
      margin-right: ${SPACING.two}px;
    }
  }
`;

export const Box = styled.div<{ isActive?: boolean; type?: CheckboxType }>`
  height: 16px;
  width: 16px;
  margin: 0;
  transition: 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ isActive }) =>
    isActive
      ? css`
          background-color: ${COLORS.highlight.five};
          border: 1px solid ${COLORS.highlight.one};
        `
      : css`
          background-color: transparent;
          border: 1px solid ${BORDER_COLORS.one};
        `};

  svg {
    transition: 0.2s ease-in-out;
    width: 16px;
    height: 16px;
    stroke: ${COLORS.highlight.one};
    stroke-width: 2;
  }
`;
